export default __webpack_public_path__ + "static/media/BusinessCard.ede81955.png";